import { render, staticRenderFns } from "./prev.vue?vue&type=template&id=1707de73&"
import script from "./prev.vue?vue&type=script&lang=js&"
export * from "./prev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports